/* eslint-disable eqeqeq */
import {ListView,Button,Toast,Modal,List } from 'antd-mobile';
import {StickyContainer, Sticky} from 'react-sticky';
import React,{useState,useEffect,useCallback} from 'react';
import SignatureCanvas from 'react-signature-canvas'
import {connect } from 'dva';
/***************************************************全局变量 begin******************************************************************** */
let pageIndex = 0;
const NUM_SECTIONS = 3;
let dataBlobs ={}; //它是一种数据结构，包含ListView所需的所有数据（section header 和 rows），如下图:
let sectionIDs = [];  //sectionIDs 用于标识每组section
let rowIDs = [];  // rowIDs 用于描述每个 section 里的每行数据的位置及是否需要渲染。在ListView渲染时，会先遍历 rowIDs 获取到对应的 dataBlob 数据。
let AAF001 = 0;
let lv;
let hasMore = true;
/***************************************************全局变量 end*********************************************************************** */
function initLet(){
  pageIndex = 0;
  dataBlobs ={}; //它是一种数据结构，包含ListView所需的所有数据（section header 和 rows），如下图:
  sectionIDs = [];  //sectionIDs 用于标识每组section
  rowIDs = [];  // rowIDs 用于描述每个 section 里的每行数据的位置及是否需要渲染。在ListView渲染时，会先遍历 rowIDs 获取到对应的 dataBlob 数据。
  AAF001 = 0;
  hasMore = true;
}
/***************************************************************************************************************** */
let getSectionData = (dataBlob, sectionID) => {
  return dataBlob[sectionID];
 };
 let getRowData = (dataBlob, sectionID, rowID) => {
  return dataBlob[sectionID + ':' + rowID];
};
let getSectionHeaderData = (dataBlob, sectionID) => dataBlob[sectionID];

const dataSource = new ListView.DataSource({
  getSectionData: getSectionData, // 获取组中数据
  getRowData: getRowData, // 获取行中的数据
  getSectionHeaderData,
  rowHasChanged: (row1, row2) => row1 !== row2,
  sectionHeaderHasChanged: (s1, s2) => s1 !== s2,
});
/*******************************************************以上是数据****************************************************** */
function renderSectionWrapper(sectionID)
{
      return (<StickyContainer
        key={`s_${sectionID}_c`}
        className="sticky-container"
          style={{ zIndex: 4 }}
        />);
}

function renderHeader(){
  return (<span>送货单</span>);
}


  //行显示
  let renderRow=(rowData, sectionID, rowID)=>
  {
    return (
      <div key={rowID} style={{ padding: '0 15px' }}>
        <div
          style={{
            lineHeight: '30px',
            color: '#888',
            fontSize: 12,
            borderBottom: '1px solid #F6F6F6',
          }}
        >{ `规格: ${rowData.AAD004}  单位:${rowData.AAD005}` }</div>
        <div style={{ display: '-webkit-box', padding: '5px 0' }}>
        {/* <img style={{ height: '64px', marginRight: '15px' }} src={this.state.img} alt="" />*/}
          
          <div style={{ lineHeight: 1 }}>
            <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>{rowData.AAD003}</div>
            <div><span style={{ fontSize: '20px', color: '#FF6E27' }}>{rowData.AAD007}</span>¥ {`x ${rowData.AAD006} = ${rowData.AAD008}`}</div>
          </div>
        </div>
      </div>
    );
  }
//间距
function renderSeparator(sectionID,rowID){
  return (
    <div
      key={`${sectionID}-${rowID}`}
      style={{
        backgroundColor: '#F5F5F9',
        height: 2,
        borderTop: '1px solid #ECECED',
        borderBottom: '1px solid #ECECED',
      }}
    />
  );
}
function onScroll(){

}
function genData(jsonData,pIndex =0){


    if(jsonData.length >0)
    {
      hasMore=true;
    }else{
      hasMore=false;
    }

  let order = [];
  for (var i in jsonData) {
      //step 1、把组数据放入sectionIDs数组中
      const ii = (pIndex * NUM_SECTIONS) + Number(i);
      sectionIDs.push(ii);
      //step 2、把组中内容放dataBlob对象中
      dataBlobs[ii] = {...jsonData[i]}

      //step 3、取出该组中所有的车
      order = jsonData[i].orderDetail;
      
      //获取最少的Id
      if(Number(AAF001)===0)
      {
        AAF001 = jsonData[i].AAF001;
      }else if(Number(jsonData[i].AAF001)< Number(AAF001)){
          AAF001 = jsonData[i].AAF001;
      }
      
      //step 4记录每一行中的数据
      rowIDs[ii] = [];
      //step 5、获取行中每一组数据
      for (var j in order) {
          //把行号放入rowIDs中
          rowIDs[ii].push(j);
          //把每一行中的内容放dataBlob对象中
          dataBlobs[ii + ':' + j] = order[j];
      }
  }
  sectionIDs = [...sectionIDs];
  rowIDs = [...rowIDs];
}
function Order(props){

  let [LVdataSource,setDataSource] = useState(dataSource);
  let [modal_sign,setModal_sign] = useState(false);

  let [AAF003,setAAF003] = useState();
  let [signCanvas,setSignCanvas] = useState(); 
  let [W,setW] = useState();
  let [H,setH] = useState();
  let [AAF012,setAAF012] =useState();
  useEffect(()=>{
    setW(window.screen.availWidth);
    setH(window.screen.availHeight);
    initLet();
    getDate();
    console.log(lv);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[0]);
  
  let getDate = useCallback(()=>{
    props.dispatch({type:"order/getWjsOrder",payload:{
      AAA001 : localStorage.getItem("AAA001"),
      AAF002 : localStorage.getItem("AAC002"),
      AAF001 
    }}).then((res )=>{
      genData(res,pageIndex++);
      setDataSource(dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs));
    });

  },[props]);
  let onClose = key => () => {
    if(key == 'modal_sign')
    {
      setModal_sign(false);
    }
  }
  let onEndReached = useCallback(()=>{
    if (props.isLoading ) {
      return;
    }
    if(hasMore==false)
    {
      return;
    }
    getDate(props);
  },[getDate, props]);

 let renderFooter = useCallback(()=>{
  return (
    <div style={{ padding: 30, textAlign: 'center' }}>{ hasMore?(props.isLoading ? '请稍等正在加载...' : '加载完成'):'亲掉头吧...没有数据了'}</div>
  );
 },[props]);


let handleQrsh = useCallback((data)=>{
    
    props.dispatch({type:"order/shouHuoQueRenUpdate",payload:{
        in_AAA001:data.AAA001,
        in_AAC002:data.AAF002,
        in_AAF003:data.AAF003,
        in_nickname:localStorage.getItem("nickname")
    }}).then((res)=>{
        if(res.codes=="NOERROR")
        {
            initLet();
            Toast.success(res.message,1,getDate,true);
        }else{
            Toast.success(res.message,5,null,true);
        }

    });

},[getDate, props]);

let modalQrsh = useCallback((data)=>{

  Modal.alert("收货确认",`送货日期:${data.AAF008} 金额:${data.AAF013} 确认已收到货吗？`,[
    { text: '取消', style: 'default' },
    { text: '确认收到', onPress: () => handleQrsh(data) },
    
  ],'ios');
},[handleQrsh]);

let clear = useCallback(()=>{
  signCanvas.clear()
},[signCanvas]);

let showSign = useCallback((sectionData)=>{
    setModal_sign(true);
    setAAF012(sectionData.AAF012);
    setAAF003(sectionData.AAF003);
},[]);

let save = useCallback(()=>{

  if(signCanvas.isEmpty())
  {
    Modal.alert("提示",`请签名！`,[
      { text: '确认', style: 'default' },
    ],'ios');
    return;

  }
  //setTrimmedDataURL(signCanvas.toDataURL('image/png'));
 
  props.dispatch({type:"order/af01_Sign",payload:{
    AAA001:localStorage.getItem("AAA001"),
    AAF003,
    AAF012,
    image : signCanvas.toDataURL('image/png'),
  }}).then((res)=>{
    console.log(res);
    Modal.alert("提示",res.message,[
      { text: '确认', style: 'default' },
    ],'ios');
    if(res.codes == 'NOERROR')
    {
      setModal_sign(false);
      initLet();
      getDate();
    }
  });
  

},[AAF003, AAF012, getDate, props, signCanvas]);


let signShow = useCallback(()=>{
  return (
    <div>
         <Modal
    popup
    visible={modal_sign}
    animationType="slide-up"
    afterClose={() => { console.log() }}
     style={{width:W, height: (H-190)}}
    >
    <List 
    className="popup-list" >
    <div style={{position:'fixed',display: 'grid',gridTemplateColumns: '1fr 10fr'}}>

      <div style={{textAlign:'left',borderLeft:'5px solid #999999',borderTop:'5px solid #999999',borderBottom:'5px solid #999999'}}>
      <Button type="primary"  disabled={props.isLoading} loading={props.isLoading} onClick={onClose('modal_sign')}  size="small" style={{ transform:'rotate(+90deg)',marginTop:(H/9),marginRight:'0px',marginLeft:'0px'}} >关闭</Button>
      <Button type="primary"  disabled={props.isLoading} loading={props.isLoading} onClick={clear}  size="small" style={{ transform:'rotate(+90deg)',marginTop:(H/5),marginRight:'0px',marginLeft:'0px'}} >重签</Button>
      <Button type="primary"  disabled={props.isLoading} loading={props.isLoading} onClick={save}  size="small" style={{ transform:'rotate(+90deg)',marginTop:(H/9),marginRight:'0px',marginLeft:'0px'}} >确认</Button>
      </div>

      <div style={{border:'5px solid #999999',marginBottom:'1px'}}>
              <SignatureCanvas penColor='black'
              ref ={value=>setSignCanvas(value)}
              style={{transform:'rotate(+90deg)'}}
              canvasProps={{width:(W-100), height: (H-190-16), className: 'sigCanvas'}} />
            
      </div>
    
    </div>
    </List>

 </Modal>

    </div>
     
  );

},[H, W, clear, modal_sign, props.isLoading, save])


 //标题吸顶
function renderSectionHeader(sectionData){
    return(
      <Sticky>
       {({
        style,
        }) => (
        <div
            className="sticky"
              style={{
              ...style,
                zIndex: 4,
                 backgroundColor: sectionData.AAF015!="5" ? '#5890ff' : 'red',
                 color: 'white',
                }}
            >{`${sectionData.AAF008} 总金额:${sectionData.AAF013}   `}{sectionData.AAF015=="5" ? '已结算':'未结算'}
            <br/>
            {`收货: `}{sectionData.AAF016=="2" ? `已确认[${sectionData.AAF017}]`:'未确认'}<br/>
            {`订单号: `}{sectionData.AAF003}&nbsp;&nbsp;{sectionData.AAF021==2?'已签名':'未签名'}
            <br/>
            {sectionData.AAF016!="2" ? (<Button type="warning" onClick={()=> modalQrsh(sectionData)} inline size="small" style={{ marginRight: '1px' }}>收货确认</Button>)
             : null}
             {sectionData.AAF021!="2" ? (<Button type="warning" disabled={props.isLoading} loading={props.isLoading} onClick={()=> showSign(sectionData)} inline size="small" style={{ marginRight: '1px' }}>签名</Button>)
             : null}
            
            </div>
            )}
            </Sticky>
            )
  }
  return (
    <div>
       <ListView
    ref={el => lv = el}
    dataSource={LVdataSource}
    className="am-list sticky-list"
    useBodyScroll
    renderSectionWrapper={renderSectionWrapper}
    renderSectionHeader={renderSectionHeader}
    renderHeader={renderHeader}
    renderFooter={renderFooter}
    renderRow={renderRow}
    renderSeparator={renderSeparator}
    pageSize={5}
    onScroll={onScroll}
    scrollEventThrottle={200}
    onEndReached={onEndReached}
    onEndReachedThreshold={10}
  />
   {signShow()}

    </div>
   
  )
}
export default connect(state=>{
  return{
    ...state.order,
    isLoading: state.loading.global
  }
})(Order)  ;